export default function(specifier) {
  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale-chromatic/src/colors.js
// module id = 9
// module chunks = 0